import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// ---------------------------------------------------------------------------
// Bootstrap de marque (runtime, depuis environment) : gtag, favicon, palette.
// Les éléments brand-specific ne sont PAS dans index.html pour que le même
// index serve aux deux marques via fileReplacements sur environment*.ts.
// ---------------------------------------------------------------------------

// Google Analytics (gtag) — id différent par marque
(() => {
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://www.googletagmanager.com/gtag/js?id=' + environment.gtagId;
  document.head.appendChild(s);
  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).gtag = function () {
    (window as any).dataLayer.push(arguments);
  };
  (window as any).gtag('js', new Date());
  (window as any).gtag('config', environment.gtagId);
})();

// Favicon (png Losange / jpg Rosace)
(() => {
  let link = document.querySelector<HTMLLinkElement>("link[rel='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = environment.favicon;
})();

// Palette de marque : les composants utilisent var(--blue), var(--blue-2), …
// Les valeurs par défaut (Losange) vivent dans theme/variables.scss ; on
// réapplique systématiquement celles de l'environnement courant.
(() => {
  const p = environment.palette as Record<string, string>;
  const root = document.documentElement;
  const map: Record<string, string> = {
    '--blue': p['blue'],
    '--blue-rgb': p['blueRgb'],
    '--blue-hover': p['blueHover'],
    '--blue-2': p['blue2'],
    '--home-title': p['homeTitle'],
    '--gfus-banner-bg': p['gfusBannerBg'],
    '--home-icon-bg': p['homeIconBg'],
    '--contact-item-bg': p['contactItemBg'],
    '--global-box-bg': p['globalBoxBg'],
    '--global-box-hover': p['globalBoxHover'],
    '--btn-disabled-bg': p['btnDisabledBg'],
    '--file-upload-btn-bg': p['fileUploadBtnBg'],
    '--file-upload-btn-hover': p['fileUploadBtnHover'],
    '--section-title': p['sectionTitle'],
  };
  Object.entries(map).forEach(([k, v]) => root.style.setProperty(k, v));
})();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
